import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'duration',
  standalone: true,
})
export class DurationPipe implements PipeTransform {
  transform(timeInMinutes: number): string {
    const hours = Math.floor(timeInMinutes / 60);
    const minutes = timeInMinutes % 60;
    let formattedHours = `${hours}`;
    if (hours < 10) {
      formattedHours = '0' + formattedHours;
    }
    let formattedMinutes = `${minutes}`;
    if (minutes < 10) {
      formattedMinutes = '0' + formattedMinutes;
    }
    if (formattedHours === '00' && formattedMinutes === '00') {
      return '-';
    }
    return `${formattedHours}:${formattedMinutes}`;
  }
}
